import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import LogoutView from './components/Logout.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import TurnosView from './components/views/Turnos.vue'
import MaquinasView from './components/views/Maquinas.vue'
import RelatoriosGeraisView from './components/views/RelatoriosGerais.vue'
import RelatoriosProducaoView from './components/views/RelatoriosProducao.vue'
import RelatoriosProducaoTagView from './components/views/RelatoriosProducaoTag.vue'
import RelatoriosProducaoPedidosTempoView from './components/views/RelatoriosProducaoPedidosTempo.vue'
import ImportarProgramacaoView from './components/views/ImportarProgramacao.vue'
import OEEView from './components/views/OEE.vue'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/logout',
    component: LogoutView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Disponibilidade',
        meta: {
          description: 'Informações de Disponibilidade',
          requiresAuth: true
        }
      }, {
        path: 'oee',
        alias: '',
        component: OEEView,
        name: 'OEE',
        meta: {
          description: 'Painel OEE',
          requiresAuth: true
        }
      }, {
        path: 'importar',
        alias: '',
        component: ImportarProgramacaoView,
        name: 'Importar',
        meta: {
          description: 'Importar Programação',
          requiresAuth: true
        }
      }, {
        path: 'turnos',
        alias: '',
        component: TurnosView,
        name: 'Turnos',
        meta: {
          description: 'Período de Produção das Máquinas',
          requiresAuth: true
        }
      }, {
        path: 'maquinas',
        alias: '',
        component: MaquinasView,
        name: 'Máquinas',
        meta: {
          description: 'Configuração das Máquinas',
          requiresAuth: true
        }
      }, {
        path: 'relatorios-gerais',
        component: RelatoriosGeraisView,
        name: 'Relatórios Gerais',
        meta: {
          description: 'Visualização concentrada de todos relatórios',
          requiresAuth: true
        }
      }, {
        path: 'relatorios-producao',
        component: RelatoriosProducaoView,
        name: 'Percentual de Operação',
        meta: {
          description: 'Relatório de percentual de tempo em operação por período',
          requiresAuth: true
        }
      }, {
        path: 'relatorios-producao-tag',
        component: RelatoriosProducaoTagView,
        name: 'Relatório de Produção',
        meta: {
          description: 'Relatório de total produzido por período',
          requiresAuth: true
        }
      }, {
        path: 'relatorios-producao-desempenho',
        component: RelatoriosProducaoPedidosTempoView,
        name: 'Relatório de Desempenho',
        meta: {
          description: 'Relatório de desempenho da produção',
          requiresAuth: true
        }
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js